// Row 3.10 — the shell's not-found surface, wired as TanStack Router's `defaultNotFoundComponent`
// (router.tsx). Renders ShellForbidden's existing "sealed" reason rather than inventing separate
// copy: a truly-unmatched route and a wall-sealed resource are both "there is nothing here for
// you" — and the backend's own design (useScopeData.ts's ScopeSealedOrMissingError; wall.py's
// authorize_reader) deliberately makes "missing" and "sealed" indistinguishable at the data layer,
// so the shell shouldn't pretend to distinguish them at the routing layer either. This is a joint
// 3.10+3.11 decision (pre-build critique, MED, disclosed here rather than silently bundled into
// this MED-severity row).
import type { ReactElement } from "react";
import { ShellForbidden } from "../components/ShellForbidden";

export function NotFoundPage(): ReactElement {
  return <ShellForbidden reason="sealed" />;
}
